
function Footer() {
    return (
        <footer>
            <p>&copy; Today I learned Inc. <span id="copyright-year">{new Date().getFullYear()}</span></p>
        </footer>
    );
}
  
export default Footer;